import { useEffect, useRef } from 'react';

import { extractUTMParameters } from '@/utils/tracking/utm/extractor';
import { shouldCaptureUTM, storeUTMParameters } from '@/utils/tracking/utm/storage';

/**
 * Custom hook to capture and manage UTM parameters
 * Use this in your _app.tsx or main layout component
 */
export function useUTMCapture() {
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Only run once per app session and only on client side
    if (hasInitialized.current || typeof window === 'undefined') return;
    hasInitialized.current = true;

    // Check if there are any URL parameters at all
    if (!window.location.search) return;

    // Extract UTM parameters directly from the current URL
    const currentUTM = extractUTMParameters(window.location.href);
    const hasUTMParams = Object.values(currentUTM).some((value) => value !== undefined);

    if (hasUTMParams && shouldCaptureUTM(currentUTM)) {
      storeUTMParameters(currentUTM);
      console.log('UTM parameters captured from external source:', currentUTM);
    }
  }, []); // Empty dependency array - run once on mount
}
